export default __webpack_public_path__ + "high20b77e.png";